import React from 'react';
import { Link } from 'react-router-dom';
import InstallMenuItem from './InstallMenuItem';

const Drawer = ({ isOpen, onClose }) => {
  return (
    <>
      {/* オーバーレイ */}
      {isOpen && <div className="fixed inset-0 bg-black bg-opacity-30 z-40" onClick={onClose} />}

      {/* ドロアー本体 */}
      <div
        className={`fixed top-0 left-0 h-full w-64 bg-white shadow-md z-50 transform transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="p-4 border-b font-bold text-lg">メニュー</div>
        <ul className="p-4 space-y-2">
          <li>
            <Link to="/" onClick={onClose} className="block text-blue-700 w-full text-left">
              ホーム
            </Link>
          </li>
          <li>
            <Link to="/help" onClick={onClose} className="block text-blue-700 w-full text-left">
              使い方
            </Link>
          </li>
          <li>
            <Link
              to="/disclaimer"
              onClick={onClose}
              className="block text-blue-700 w-full text-left"
            >
              免責事項
            </Link>
          </li>
          <InstallMenuItem onClose={onClose} />
        </ul>
      </div>
    </>
  );
};

export default Drawer;
